import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import setRecentlyViewedItemsOperation from 'store/studioSearch/operation/setRecentlyViewedItemsOperation';
import { GettyImagesImageSearchResponseImage } from 'store/studioSearch/types';

const RECENTLY_VIEWED_STUDIO_KEY = 'recently_viewed_studio';
const RECENTLY_VIEWED_STUDIO_SEARCH_BAR_KEY = 'opRecentlyViewed';
const MAX_STORED = 30;

type StoredGettyImage = {
  gettyImageId: string;
  url: string;
};

const storedGettyImageAdapter = (image: GettyImagesImageSearchResponseImage): StoredGettyImage => {
  const { id: gettyImageId, displaySizes } = image;
  const [{ uri: url }] = displaySizes;
  return { gettyImageId, url };
};

const useLocalStudioRecentlyViewed = () => {
  const dispatch = useDispatch();

  const getStored = (): GettyImagesImageSearchResponseImage[] => {
    const stored = localStorage.getItem(RECENTLY_VIEWED_STUDIO_KEY) || '[]';
    const parsed = JSON.parse(stored) || [];
    return Array.isArray(parsed) ? parsed : [];
  };

  const setStored = (images: GettyImagesImageSearchResponseImage[]) => {
    localStorage.setItem(RECENTLY_VIEWED_STUDIO_KEY, JSON.stringify(images));
    localStorage.setItem(RECENTLY_VIEWED_STUDIO_SEARCH_BAR_KEY, JSON.stringify(images.map(storedGettyImageAdapter)));
  };

  const storeRecentlyViewed = (image: GettyImagesImageSearchResponseImage) => {
    const images = [
      image,
      ...getStored()
        .filter((i) => i.id !== image.id)
        .slice(0, MAX_STORED - 1),
    ];
    setStored(images);
    dispatch(setRecentlyViewedItemsOperation(images));
  };

  const clearRecentlyViewed = () => {
    setStored([]);
    dispatch(setRecentlyViewedItemsOperation([]));
  };

  useEffect(() => {
    dispatch(setRecentlyViewedItemsOperation(getStored()));
  }, []);

  return {
    clearRecentlyViewed,
    storeRecentlyViewed,
    getStored,
  };
};

export default useLocalStudioRecentlyViewed;
